var React = require("react");
var $ = require('jquery');
var Reflux = require('reflux');

// Stores
var LanguageStore = require('../stores/language_store');

// Job Area
module.exports = React.createClass({
	
	
	// Render
  	render: function(){
  		
  		var style = {};
  		var url = '/'+this.props.env;
  		
  		if(typeof this.props.env_info.custom_job_board_domain != 'undefined' && this.props.env_info.custom_job_board_domain != ''){
  			url = '/';
  		}
  		
  		var header_bg_url = (this.props.env_info.settings.header_bg_id != '') ? '/bg/'+this.props.env+'/'+this.props.env_info.settings.header_bg_id : '';
  		
  		if(header_bg_url != ''){
	  		style.backgroundImage = 'url('+header_bg_url+')';
  		}
  		
  		var title = 'Subscribe to updates from '+this.props.env_info.title;
  		
  		var custom_title = LanguageStore.get('job_board/title/subscribe/header');
  		
  		if(custom_title != ''){
	  		title = custom_title;
  		}
  		
  	   	return (<div className="env-header" style={style}>
   			
   			<a href={url}><img src={this.props.env_info.logo} /></a>
   			<h1>{title}</h1>
	  	</div>);
	}
});
